module.exports = __webpack_public_path__ + "img/NBL1Central.d9c7d67f.png";